import * as Unicons from '@iconscout/react-unicons';
import './tags.css';
import { useTranslation } from 'react-i18next';

interface Tag {
  tipo: string;
}

type TagsMaps = {
  [key: string]: {
    className: string;
    icon: React.ReactNode;
    color: string;
    label: string;
  };
};

export const Tags: React.FunctionComponent<Tag> = ({ tipo }: Tag) => {
  const { t } = useTranslation('common')
  const tagMap: TagsMaps = {
    sede: {
      className: 'tag-container-sede',
      icon: <Unicons.UilGlobe size="14" color="#478953" />,
      color: '#478953',
      label: t('common:tags.headquarters'),
    },
    admin: {
      className: 'tag-container-admin',
      icon: <Unicons.UilDollarSignAlt size="14" color="#306F75" />,
      color: '#306F75',
      label: t('common:tags.admin'),
    },
    colaborador: {
      className: 'tag-container-colaborador',
      icon: <Unicons.UilWrench size="14" color="#CF6D34" />,
      color: '#CF6D34',
      label: t('common:tags.collaborator'),
    },
    franquia: {
      className: 'tag-container-franquia',
      icon: <Unicons.UilGlobe size="14" color="#AA5556" />,
      color: '#AA5556',
      label: t('common:tags.franchise'),
    },
    instrutor: {
      className: 'tag-container-instrutor',
      icon: <Unicons.UilGraduationCap size="14" color="#3771A8" />,
      color: '#3771A8',
      label: t('common:tags.instructor'),
    },
    professor: {
      className: 'tag-container-instrutor',
      icon: <Unicons.UilGraduationCap size="14" color="#3771A8" />,
      color: '#3771A8',
      label: t('common:tags.teacher'),
    },
    gestor: {
      className: 'tag-container-gestor',
      icon: <Unicons.UilSetting size="14" color="#895CF2" />,
      color: '#895CF2',
      label: t('common:tags.manager'),
    },
    gerencia: {
      className: 'tag-container-gestor',
      icon: <Unicons.UilSetting size="14" color="#895CF2" />,
      color: '#895CF2',
      label: t('common:tags.manager'),
    },
    externo: {
      className: 'tag-container-sede',
      icon: <Unicons.UilTrees size="14" color="#478953" />,
      color: '#478953',
      label: t('common:tags.external'),
    },
    presencial: {
      className: 'tag-container-colaborador',
      icon: <Unicons.UilUsersAlt size="14" color="#CF6D34" />,
      color: '#CF6D34',
      label: t('common:tags.inPerson'),
    },
    online: {
      className: 'tag-container-gestor',
      icon: <Unicons.UilDesktop size="14" color="#895CF2" />,
      color: '#895CF2',
      label: t('common:tags.online'),
    },
    híbrido: {
      className: 'tag-container-franquia',
      icon: <Unicons.UilDirection size="14" color="#AA5556" />,
      color: '#AA5556',
      label: t('common:tags.hybrid'),
    },
    comercial: {
      className: 'tag-container-comercial',
      icon: <Unicons.UilDollarSignAlt size="14" color="#CF6B6C" />,
      color: '#CF6B6C',
      label: t('common:tags.commercial'),
    },
    games: { className: 'tag-games', icon: null, color: null, label: 'Games' },
    vencido: {
      className: 'tag-container-comercial',
      icon: <Unicons.UilExclamationTriangle size="14" color="#CF6B6C" />,
      color: '#CF6B6C',
      label: t('common:tags.overdue'),
    },
    pago: {
      className: 'tag-container-sede',
      icon: <Unicons.UilCheck size="14" color="#478953" />,
      color: '#478953',
      label: t('common:tags.paid'),
    },
    aberto: {
      className: 'tag-container-colaborador',
      icon: <Unicons.UilClockNine size="14" color="#CF6D34" />,
      color: '#CF6D34',
      label: t('common:tags.open'),
    },
    responsavel: {
      className: 'tag-container-gestor',
      icon: null,
      color: null,
      label: t('common:tags.responsible'),
    },
    youtube: {
      className: 'tag-youtube',
      icon: null,
      color: null,
      label: t('common:tags.youtube'),
    },
    lancado: {
      className: 'tag-container-sede',
      icon: <Unicons.UilCheck size="14" color="#478953" />,
      color: '#478953',
      label: t('common:tags.posted'),
    },
    pendente: {
      className: 'tag-container-comercial',
      icon: <Unicons.UilExclamationTriangle size="14" color="#CF6B6C" />,
      color: '#CF6B6C',
      label: t('common:tags.pending'),
    },
    nao_ocorrida: {
      className: 'tag-container-comercial',
      icon: <Unicons.UilTimesCircle size="14" color="#CF6B6C" />,
      color: '#CF6B6C',
      label: t('common:tags.notOccurred'),
    },
    acontecer: {
      className: 'tag-container-colaborador',
      icon: <Unicons.UilClockNine size="14" color="#CF6D34" />,
      color: '#CF6D34',
      label: t('common:tags.upcoming'),
    },
  };

  const tag = tagMap[tipo?.toLowerCase()];

  if (!tag) {
    return (
      <div className="tag-wrapper tag-container-gestor ">
        <Unicons.UilDesktop size="14" color="#895CF2" />
        <span>{tipo}</span>
      </div>
    );
  }

  const { className, icon, color, label } = tag;

  return (
    <div className={`tag-wrapper ${className}`}>
      {icon && icon}
      <span style={{ color }}>{label}</span>
    </div>
  );
};
